import { GraphSchema } from '@camelot/server';
import { Address } from '@camelot/services';

import { Unit } from '../../../../common/services/dto/unit';

export enum ReceptionStatus {
  Unknown = 0,
  Draft = 1,
  Validated = 2,
  Cancelled = 3,
}

export interface ReceptionRow {
  id: string;
  receptionId: string;
  purchaseOrderRowId: string;
  purchaseOrderId: string;
  purchaseOrderReference: string | null;
  orderNumber: number | null;
  purchaseOrderRowIndex: number;
  description: string | null;
  orderedQuantity: number | null;
  unit: Unit | null;
  unitCostPrice: number | null;
  deliveredQuantity: number | null;
  refusedQuantity: number | null;
  refusalReason: string | null;
  percentage: number | null;
  acceptedQuantity: number | null;
  alreadyReceived: number;
  isFinalised: boolean;
  finalisationReason: string | null;
  overReceptionAccepted: boolean;
  overReceptionAcceptedById: string | null;
  overReceptionAcceptedAt: string | null;
}

export interface Reception {
  id: string;
  reference: string | null;
  receptionNumber: number | null;
  status: ReceptionStatus;
  receptionDate: string;
  validationDate: string | null;
  cancelledDate: string | null;
  cancellationReason: string | null;
  supplierId: string;
  companyId: string;
  supplierReference: string | null;
  deliveryAddressId: string | null;
  deliveryAddress: Address | null;
  receivedById: string | null;
  comment: string | null;
  rows: ReceptionRow[];
  createdTime: string;
  updatedTime: string;
}

export const receptionProps = new GraphSchema<Reception>([
  'id',
  'reference',
  'receptionNumber',
  'status',
  'receptionDate',
  'validationDate',
  'cancelledDate',
  'cancellationReason',
  'supplierId',
  'companyId',
  'supplierReference',
  'deliveryAddressId',
  'deliveryAddress',
  'receivedById',
  'comment',
  'rows',
  'createdTime',
  'updatedTime',
]);

export const receptionRowProps = new GraphSchema<ReceptionRow>([
  'id',
  'receptionId',
  'purchaseOrderRowId',
  'purchaseOrderId',
  'purchaseOrderReference',
  'orderNumber',
  'purchaseOrderRowIndex',
  'description',
  'orderedQuantity',
  'unit',
  'unitCostPrice',
  'deliveredQuantity',
  'refusedQuantity',
  'refusalReason',
  'percentage',
  'acceptedQuantity',
  'alreadyReceived',
  'isFinalised',
  'finalisationReason',
  'overReceptionAccepted',
  'overReceptionAcceptedById',
  'overReceptionAcceptedAt',
]);

export interface ReceptionCreationPayload {
  receptionDate: string;
  purchaseOrderIds: string[];
  supplierReference?: string | null;
}

export interface ReceptionModifierPayload {
  receptionId: string;
  updatedFields: string[];
  receptionDate?: string | null;
  supplierReference?: string | null;
  receivedById?: string | null;
  comment?: string | null;
}

export interface ReceptionRowInput {
  id: string;
  deliveredQuantity: number | null;
  percentage: number | null;
  refusedQuantity: number | null;
  refusalReason: string | null;
  isFinalised: boolean;
  finalisationReason: string | null;
  overReceptionAccepted: boolean;
}

export interface ReceptionCancellationPayload {
  receptionId: string;
  reason: string;
}
